import { ArrowForwardIcon } from "@chakra-ui/icons";
import React from "react";

const ContactSection = () => {
  return (
    <section
      className="from-blue-700 to-blue-500 bg-gradient-to-tr py-24"
      id="contact"
    >
      <div className="container-sm space-y-10">
        <div className="text-center space-y-2">
          <p className="text-5xl font-semibold text-white">Contact Us</p>
          <p className="text-lg mx-auto max-w-lg leading-tight font-medium text-gray-200">
            Send us your requests, complaints, or anything in between. We'd love
            to hear from you.
          </p>
        </div>
        <form
          action="https://formspree.io/f/mvovbgvj"
          method="POST"
          className="p-10 bg-white shadow-xl rounded-xl space-y-4"
        >
          <div className="grid md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <p className="text-gray-400 uppercase font-bold tracking-wider text-sm">
                Full Name
              </p>
              <input
                required
                type="text"
                placeholder=""
                className="transition-all font-medium input"
                name="name"
              />
            </div>
            <div className="space-y-2">
              <p className="text-gray-400 uppercase font-bold tracking-wider text-sm">
                Email Address
              </p>
              <input
                required
                type="email"
                placeholder=""
                className="transition-all font-medium input"
                name="email"
              />
            </div>
          </div>
          <div className="space-y-2">
            <p className="text-gray-400 uppercase font-bold tracking-wider text-sm">
              Subject
            </p>
            <input
              required
              type="text"
              placeholder=""
              className="transition-all font-medium input"
              name="subject"
            />
          </div>
          <div className="space-y-2">
            {/* <p className="text-gray-400 uppercase font-bold tracking-wider text-sm">
              Email Address
            </p> */}
            <textarea
              required
              rows="5"
              type="text"
              placeholder=""
              className="transition-all font-medium input"
              name="body"
            />
          </div>

          <button className="mt-5 w-full flex justify-center items-center space-x-3 font-semibold transition-all px-8 py-3 rounded-md shadow duration-500 bg-blue-500 hover:bg-blue-400 text-white">
            <span>Submit</span> <ArrowForwardIcon />
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactSection;
